<template>
  <transition name="mask">
    <div class="modal-mask" v-if="show" @click.self="hideModalMask">
      <div class="modal-wrapper" :style="{width: width+'px'}">
        <div class="modal-wrap" :style="{'background-image': bg_color ? '' : bgImgs, 'background-color': bg_color}">
          <h2 :style="{'color': gc.main_color, marginBottom: '12px'}">{{title}}</h2>
          <div v-if="show_close" class="close-icon" @click="hideModalMask">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M7.05719 8.00016L3.5286 4.47157C3.26825 4.21122 3.26825 3.78911 3.5286 3.52876C3.78894 3.26841 4.21105 3.26841 4.4714 3.52876L8 7.05735L11.5286 3.52876C11.7889 3.26841 12.2111 3.26841 12.4714 3.52876C12.7318 3.78911 12.7318 4.21122 12.4714 4.47157L8.94281 8.00016L12.4714 11.5288C12.7318 11.7891 12.7318 12.2112 12.4714 12.4716C12.2111 12.7319 11.7889 12.7319 11.5286 12.4716L8 8.94297L4.4714 12.4716C4.21105 12.7319 3.78894 12.7319 3.5286 12.4716C3.26825 12.2112 3.26825 11.7891 3.5286 11.5288L7.05719 8.00016Z" :fill="gc.main_color"/>
            </svg>
          </div>
          <slot></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script type='text/ecmascript-6'>
export default {
  props: {
    width: {
      type: Number,
      default: 299
    },
    gc: {
      type: Object,
      default: () => {}
    },
    cc: {
      type: Object,
      default: () => {}
    },
    over_close: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    bg_color: {
      type: String,
      default: ''
    },
    show_close: {
      type: Boolean,
      default: true
    }
  },
  computed :{
    // 优先选择component_conf的modal_bg，没有的话用common_conf的modal_bg
    bgImgs () {
      let obj = this.cc
      if (!obj.modal_bg || !obj.modal_bg.top) {
        obj = this.gc
      }
      return `url(${obj.modal_bg.top}), url(${obj.modal_bg.mid}), url(${obj.modal_bg.bot})`
    }
  },
  data () {
    return {
      show: false
    }
  },
  methods: {
    showModal () {
      this.show = true
      this._top = document.scrollingElement.scrollTop
      document.body.classList.add('body-fixed')
      document.body.style.top = -this._top + 'px'
    },
    hideModal () {
      this.show = false
      document.body.classList.remove('body-fixed')
      document.scrollingElement.scrollTop = this._top;
      this.$emit('closeModal')
    },
    hideModalMask () {
      if (!this.over_close) {
        return
      }
      this.hideModal()
    }
  }
}
</script>

<style lang='less'>
.modal-mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(#000, 0.5);
  z-index: 50;
  .modal-wrapper {
    width: 248px;
    min-height: 116px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
    .modal-wrap {
      width: 100%;
      position: relative;
      z-index: 2;
      background-size: 100% 31px, 100% calc(100% - 60px), 100% 31px;
      background-repeat: no-repeat;
      background-position: center top, center center, center bottom;
      padding: 20px;
    }
    h2 {
      font-weight: 500;
      line-height: 26px;
      font-size: 18px;
      letter-spacing: 0.25px;
      text-align: center;
    }
    .close-icon {
      width: 16px;
      height: 16px;
      position: absolute;
      top: 16px;
      right: 16px;
      z-index: 10;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .modal-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      display: flex;
      flex-direction: column;
      background-size: 100% auto;
      background-repeat: repeat;
      background-position: center;
      .bg-top, .bg-bot {
        width: 100%;
        padding-top: 12.0967742%;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
      }
      .bg-mid {
        width: 100%;
        height: 0;
        flex: 1;
        background-size: 100% auto;
        background-repeat: repeat;
        background-position: center;
      }
    }
  }
}
.mask-enter-active, .mask-leave-active {
  transition: all 0.35s cubic-bezier(0.24, 0.01, 0.24, 1);
}
.mask-enter, .mask-leave-to {
  opacity: 0;
}
.mask-enter-to, .mask-leave {
  opacity: 1;
}
.modal-content {
  display: flex;
  flex-direction: column;
  .msg {
    line-height: 20px;
    font-size: 14px;
    text-align: center;
    margin-top: 12px;
    opacity: .8;
  }
  .distribute-desc {
    line-height: 16px;
    font-size: 11px;
    margin: 14px 0 0;
    text-align: center;
  }
  .btn-done {
    height: 36px;
    width: 100%;
    line-height: 36px;
    text-align: center;
    color: #FFF;
    margin-top: 16px;
    font-size: 16px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
}
</style>